(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["advent-hero"]) return;
  try {
    
  function startCountdown() {
    const el = document.querySelector('[data-countdown="days"]');
    if (!el) return;
    const targetAttr = document.querySelector('.advent-countdown')?.dataset?.target;
    const targetDate = targetAttr ? new Date(targetAttr).getTime() : new Date('2026-12-01T00:00:00').getTime();

    function updateCountdown() {
      const now = new Date().getTime();
      const difference = Math.max(0, targetDate - now);

      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((difference % (1000 * 60)) / 1000);

      const d = document.querySelector('[data-countdown="days"]');
      const h = document.querySelector('[data-countdown="hours"]');
      const m = document.querySelector('[data-countdown="minutes"]');
      const s = document.querySelector('[data-countdown="seconds"]');
      if (d) d.textContent = String(days).padStart(2, '0');
      if (h) h.textContent = String(hours).padStart(2, '0');
      if (m) m.textContent = String(minutes).padStart(2, '0');
      if (s) s.textContent = String(seconds).padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  startCountdown();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-urgency"]) return;
  try {
    
  function startUrgencyCountdown() {
    // Countdown jusqu'à minuit demain
    const now = new Date();
    const tomorrow = new Date(now);
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    const targetTime = tomorrow.getTime();

    function updateCountdown() {
      const currentTime = new Date().getTime();
      const difference = targetTime - currentTime;

      if (difference > 0) {
        const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        document.querySelector('[data-countdown="hours"]').textContent = String(hours).padStart(2, '0');
      }
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  startUrgencyCountdown();

  } catch(e) { console.error(e); }
})();
})();
